import { MarketingFlowDetails } from "modules/marketing";
import { useParams } from "react-router-dom";

const MarketingFlowPage = () => {
  const { flowId } = useParams();

  if (!flowId) return null;

  return <MarketingFlowDetails flowId={flowId} />;
};

export default MarketingFlowPage;
